import { createRequestActionTypes } from '../../helpers'

export const FETCH_START_CONTENT = createRequestActionTypes(
  'START_CONTENT',
  'START_CONTENT'
)



// WEBPACK FOOTER //
// ./src/containers/GettingStarted/constants.js